export function MP() {
    return new Promise(function (resolve, reject) {
        window.init = function () {
            resolve(BMap)
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = `http://api.map.baidu.com/api?v=3.0&ak=QLCfdWECkA9IpiOF2zf3oSCzdzzUHUSD&callback=init`
        script.onerror = reject
        document.head.appendChild(script)
    })
}



// WEBPACK FOOTER //
// ./src/assets/js/map.js